import { render, staticRenderFns } from "./ProductSkuSpecSections.vue?vue&type=template&id=7ede0016&scoped=true"
import script from "./ProductSkuSpecSections.vue?vue&type=script&lang=js"
export * from "./ProductSkuSpecSections.vue?vue&type=script&lang=js"
import style0 from "./ProductSkuSpecSections.vue?vue&type=style&index=0&id=7ede0016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ede0016",
  null
  
)

export default component.exports